import "@/styles/vendor.css";
import "@/styles/index.css";

import paginatedList from "@/scripts/components/paginated-list";
import scrollReveal from "@/scripts/components/scroll-reveal";
import scrollTo from "@/scripts/components/scroll-to";
import siteHeader from "@/scripts/components/site-header";
import siteFooter from "@/scripts/components/site-footer";
import slideToggle from "@/scripts/components/slide-toggle";

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import { dropdown } from "@/scripts/alpine/dropdown";

paginatedList.init();
scrollReveal.init();
scrollTo.init();
siteHeader.init();
siteFooter.init();
slideToggle.init();

Alpine.plugin(focus);
Alpine.data("dropdown", dropdown);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});

/**
 * Workaround for no safelist
 * class="text-brand-brown text-brand-blue text-brand-orange text-brand-green"
 */
